<agpr-dialog-container
    heading="Discover.csvInteractionExport.header"
    [id]="'csvInteractionExportDialog'"
    [contentPadding]="false"
    (close)="cancel()"
>
    <div 
        class="agpr-csvInteractionExport"
        [agprLoading]="loading"
    >
        <div class="agpr-csvInteractionExport-lhp">
            <agpr-scroll-panel>
                <div>
                    {{'Discover.csvInteractionExport.instructions' | localize}}
                </div>
                <div class="agpr-csvInteractionExport-dateSelector">
                    <label
                        class="agpr-csvInteractionExport-dateSelector-heading"
                        [id]="id + '_dateFilterOptions'"
                    >
                        {{ 'Discover.csvInteractionExport.dateRangeLabel' | localize }}
                    </label>
                    <agpr-date-query-popup
                        [(ngModel)]="dateQuery"
                        [header]="'Monitoring.dateQueryDialog.header'"
                        [options]="dateFilterOptions"
                        [hideDateTypeSelection]="true"
                        (ngModelChange)="getEntityCount()"
                        [ariaLabelledBy]="id + '_dateFilterOptions'"
                    >
                    </agpr-date-query-popup>
                </div>
    
                <div class="agpr-csvInteractionExport-fieldContainer">
                    <div class="agpr-csvInteractionExport-fieldContainer-header">
                        {{ 'Discover.batchActions.interactionExport.group.includedInteractionTypes' | localize }}
                    </div>
                    <ul class="agpr-csvInteractionExport-fieldContainer-grid">
                        <li
                            *ngFor="let field of includedInteractionTypes"
                            class="agpr-csvInteractionExport-fields-section"
                        >
                            <agpr-checkbox
                                [id]="field.enumValue + '_checkbox'"
                                [label]="field.label"
                                [value]="field"
                                [(ngModel)]="selectedTypeFields"
                                (ngModelChange)="typeChange()"
                            >
                            </agpr-checkbox>
                        </li>
                    </ul>
                </div>
    
                <div class="agpr-csvInteractionExport-fieldContainer">
                    <div class="agpr-csvInteractionExport-fieldContainer-header">
                        {{ 'Discover.batchActions.interactionExport.group.includedInteractionData' | localize }}
                    </div>
                    <ul class="agpr-csvInteractionExport-fieldContainer-grid">
                        <li
                            *ngFor="let field of includedInteractionData"
                            class="agpr-csvInteractionExport-fields-section"
                        >
                            <agpr-checkbox
                                [id]="field.enumValue + '_checkbox'"
                                [label]="field.label"
                                [value]="field"
                                [(ngModel)]="selectedDataFields"
                                (ngModelChange)="validate()"
                            >
                            </agpr-checkbox>
                        </li>
                    </ul>
                </div>
            </agpr-scroll-panel>
        </div>
        <div class="agpr-csvInteractionExport-rhp">
            <agpr-scroll-panel>
                <div class="agpr-csvInteractionExport-rhp-content">
                    <agpr-text-input
                        [id]="'csvInteractionExportDialog.filenameInput'"
                        [(ngModel)]="filename"
                        placeholder="Discover.csvExport.filename.placeholder"
                        label="Discover.csvExport.filename.label"
                        [required]="true"
                        [maxLength]="255"
                        (ngModelChange)="validate()"
                    ></agpr-text-input>
                    <div class="agpr-csvInteractionExport-chipContainer">
                        @if (selectedTypeFields.length > 0) {
                            <div class="agpr-csvInteractionExport-chipContainer-label">
                                {{'Discover.batchActions.interactionExport.group.includedInteractionTypes' | localize}}
                            </div>
                            <div class="agpr-csvInteractionExport-chipContainer-chipSection">
                                <agpr-chip-container 
                                    [readonly]="true"
                                    [chips]="selectedTypeFields"
                                    [plainMode]="true"
                                    [noTooltips]="true"
                                ></agpr-chip-container>
                            </div>
                        }
                        @if (selectedTypeFields.length > 0) {
                            <div class="agpr-csvInteractionExport-chipContainer-label">
                                {{'Discover.batchActions.interactionExport.group.includedInteractionData' | localize}}
                            </div>
                            <div class="agpr-csvInteractionExport-chipContainer-chipSection">
                                <agpr-chip-container
                                    [readonly]="true"
                                    [chips]="selectedDataFields"
                                    [plainMode]="true"
                                    [noTooltips]="true"
                                ></agpr-chip-container>
                            </div>
                        }
                    </div>
                </div>
            </agpr-scroll-panel>

            <div class="agpr-csvInteractionExport-countContainer">
                <agpr-message [severity]="messageSeverities.info">
                    {{
                        'Discover.batchActions.interactionExport.count' | localize : { contactCount: contactCount, outletCount: outletCount}
                    }}
                </agpr-message>
            </div>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.confirmDialog.cancel'"
            label="Core.button.cancel"
            [disabled]="loading"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.confirmDialog.ok'"
            [style]="buttonTypes.primary"
            label="Discover.batchActions.export"
            [agprTooltip]="exportTooltip | localize"
            [disabled]="loading || !isExportValidate"
            (click)="ok()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
